import { Component, input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FHIRPractitioner } from '../../../../models';
import { FhirMapperService } from '../../../../../core/services';

@Component({
  selector: 'app-practitioners-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './practitioners-section.component.html',
})
export class PractitionersSectionComponent {
  private readonly mapper = inject(FhirMapperService);

  readonly practitioners = input.required<FHIRPractitioner[]>();

  getPractitionerData(pract: FHIRPractitioner) {
    return this.mapper.mapPractitioner(pract);
  }
}
